const WAVE_BODY_HEIGHT = 200;
const WAVE_CURVE_HEIGHT = 112;
const WAVE_PATH_D =
  'M0 0L428 0 428 70C428 70 393 57.972 313 61 233 64.028 207 111 113.5 111 20 111 0 70 0 70Z';

interface WaveHeroProps {
  fillColor?: string;
  surfaceColor?: string;
}

/**
 * Shared hero-wave primitive.
 *
 * Platform-specific spacing is provided by CSS variables on the page container:
 * - --page-wave-top-fill: colored area above the curve
 * - --page-wave-fill-color / --page-wave-surface-color: theme colors
 *
 * The wave geometry itself stays identical on every platform.
 */
export function WaveHero({
  fillColor = 'var(--page-wave-fill-color, hsl(var(--primary)))',
  surfaceColor = 'var(--page-wave-surface-color, hsl(var(--background)))',
}: WaveHeroProps) {
  return (
    <div
      className="absolute left-0 top-0 w-full pointer-events-none z-0"
      style={{
        height: `calc(var(--page-wave-top-fill, 0px) + ${WAVE_BODY_HEIGHT}px - var(--page-wave-lift, 0px))`,
        background: fillColor,
      }}
    >
      <svg
        className="absolute bottom-0 left-0 w-full"
        style={{ height: `${WAVE_CURVE_HEIGHT}px` }}
        viewBox="0 0 428 112"
        preserveAspectRatio="none"
      >
        <rect width="428" height="112" fill={surfaceColor} />
        <path d={WAVE_PATH_D} fill={fillColor} />
      </svg>
    </div>
  );
}
